export default function AreaModalController() {
  return <i className={"bi-map-fill text-white"}></i>;
}
